import styled from '@emotion/styled';
import { Alert } from '@robinpowered/ui-kit';
import { Trans } from 'react-i18next';

export const CancelReservationDelegationWarning = ({
  showDelegatedWarning,
  reservationReserveeName,
  reservationReserverName,
}: {
  showDelegatedWarning: boolean;
  reservationReserveeName?: string | null;
  reservationReserverName?: string | null;
}): JSX.Element | null => {
  if (
    !showDelegatedWarning ||
    !reservationReserveeName ||
    !reservationReserverName
  ) {
    return null;
  }

  return (
    <Alert
      message={
        <Trans
          i18nKey="bookings.cancelReservationModal.delegated_warning"
          ns="peopleProfileSidebar"
          values={{
            reserveeName: reservationReserveeName,
            reserverName: reservationReserverName,
          }}
          components={{ b: <HighlightedName /> }}
        />
      }
      type="warning"
      showIcon
    />
  );
};

const HighlightedName = styled.span`
  font-weight: 700;
`;
